<template>
  <div class="app__product">
    <div class="app__diamond app__diamond--top app__diamond--white"></div>
    <Close />
    <div class="app__productWrapper" v-if="step.products">
      <div class="app__productWrapper2" data-compare>

        <StepLabel :step="step.step_number"/>
        <Steps :max-steps="maxSteps" :active-step="step.step_number" :steps="steps"/>

        <div class="app__productTitle" v-html="step.title"></div>
        <div class="app__productButtonCompare app__productButtonCompare--right">

          <a href="#"
             class="btn btn__link"
             data-compare-button
             :data-compare-button-start="step.compare.compare_label_button_start"
             :data-compare-button-redirect="step.compare.compare_label_button_redirect"
             :data-compare-redirect="step.compare.compare_url_redirect.url">

            <span data-compare-label class="small">{{step.compare.compare_label_button_start}}</span>
            <i class="icon-strzalka"></i>
          </a>
        </div>

        <div class="app__productInnerCompare">
          <div class="app__compareWrapper" v-for="product in step.products">

            <div class="app__compare" >
              <div class="cartProduct" :data-compare-product="product.ID">

                <div class="cartProduct__wrapper">
                  <a :href="product.url" target="_self" ref="nofollow" class="cartProduct__image">
                    <img :src="product.image" :alt="product.title">
                  </a>

                  <a :href="product.url" target="_self" :title="product.title" class="cartProduct__title">
                    {{ product.title }}
                  </a>

                  <div class="cartProduct__category" v-if="product.category">
                    <a :href="product.category.url" target="_self">
                      {{product.category.name}}
                    </a>
                  </div>

                  <div class="cartProduct__button" v-if="product">
                    <a :href="product.url" class="btn btn__link btn__rightIcon" target="_self" ref="nofollow">
                      {{ product.compare }} <i class="icon-strzalka"></i>
                    </a>
                  </div>

                </div>
              </div>
            </div>

            <div class="app__productUpSell app__productUpSell--prl15" v-if="product.up_sell_is_active">
              <div class="app__productUpSellImage app__productUpSellImage--w100">
                <img :src="product.up_sell.image_path" :alt="product.up_sell.name">
              </div>
              <div class="app__productUpSellDesc app__productUpSellDesc--w100" v-html="product.up_sell.description"></div>
            </div>
          </div>
        </div>

        <div class="app__productButton">
          <button class="btn btn__primary" @click="setStart()">{{ step.label_text }} <i class="icon-strzalka"></i></button>
        </div>
      </div>
    </div>
    <div class="app__diamond app__diamond--bottom app__diamond--green2"></div>
  </div>
</template>

<script>
import EventBus from "../../event-bus.js";
import Close from "./../Parts/Close.vue";
import StepLabel from './../Parts/StepLabel.vue';
import Steps from './../Parts/Steps.vue';
import axios from "axios";

export default {
  props: ['settings', 'currentStep', 'step', 'steps', 'maxSteps', 'restUrlProduct', 'path'],
  components: {
    Close,
    StepLabel,
    Steps
  },
  data: () => ({
    active: false,
    product: {}
  }),
  mounted() {

    this.$nextTick(() => {
      window.triggerEvent('compare_product_reinit', null);
    });

    this.product = this.step.product;
  },
  methods: {
    setStart() {
      EventBus.$emit('SET_START', 0);
    }
  }
}
</script>
